import React from 'react';

import { Layout, Menu } from 'antd';
const { Header, Content } = Layout;

import logo from 'images/SAS-Logo_rev.png';
import { getBrandBlue } from '../../theme';

export default class App extends React.Component {
	constructor() {
		super();
		this.state = { blue: '#0669aa', id: '1' };
	}
	state = {
		blue: '#0069aa',
	};
	componentDidMount() {
		const blue = getBrandBlue();
		this.setState({ blue });
		document.body.style.backgroundColor = blue;
	}

	componentDidUpdate(prevProps) {
		if (
			this.props.props.isStaff !== prevProps.props.isStaff ||
			this.props.props.isStudent !== prevProps.props.isStudent ||
			this.props.props.isLLL !== prevProps.props.isLLL ||
			this.props.props.isFaculty !== prevProps.props.isFaculty
		) {
			this.setState({ props: this.props });
		}

	}

	render() {
		let backLink = "https://semesteratsea.my.site.com";
		if(this.state && this.state.props && this.state.props.props && this.state.props.props.isStudent){
			backLink = "https://semesteratsea.my.site.com/portal/TX_SiteLogin?startURL=%2Fportal%2FTargetX_Base__Portal";
		}
		if(this.state && this.state.props && this.state.props.props && this.state.props.props.isLLL){
			backLink = "https://semesteratsea.my.site.com/lllportal/TX_SiteLogin?startURL=%2Flllportal%2FTargetX_Base__Portal";
		}
		if((this.state && this.state.props && this.state.props.props && this.state.props.props.isStaff) || (this.state && this.state.props && this.state.props.props && this.state.props.props.isFaculty)){
			backLink = "https://semesteratsea.my.site.com/stacultyportal/TX_SiteLogin?startURL=%2Fstacultyportal%2FTargetX_Base__Portal";
		}
		const showMenu =
			window.location.hash.indexOf('portal') !== -1 || window.location.hash.indexOf('deposit') !== -1;
		return (
			<Layout key={this.state.id}>
				<Header
					style={{
						background: this.state.blue,
						padding: '8pt 0 4pt 16pt',
						minHeight: '90px',
						height: 'auto',
					}}
				>
					<img style={{ maxHeight: '60px', marginTop: '10px' }} src={logo} alt='logo' />
					<span className='logoTitle'>Programs&nbsp;and&nbsp;Payment</span>
					{showMenu && (
						<Menu mode='horizontal' style={{ background: this.state.blue, float: 'right' }}>
							{this.props.props.isStudent ||
							this.props.props.isLLL ||
							this.props.props.isFaculty ||
							this.props.props.isStaff ? (
								<Menu.Item>
									<a href={backLink} style={{ color: 'white' }}>
										Back to my Community Portal
									</a>
								</Menu.Item>
							) : null}
						</Menu>
					)}
				</Header>
				<Content>{this.props.children}</Content>
			</Layout>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/App/index.jsx